import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  DialogActions,
  Button,
  CircularProgress,
} from "@material-ui/core";

const styles = (theme) => ({
  // Must be on Dialog root (Modal), not paper — paper z-index does not lift the portal.
  // EditCustomer uses paperAnchorHighZIndex (1400) when opened from Pro Info / Dispatch.
  root: {
    zIndex: 1401,
  },
  dialog: {
    padding: "18px 24px",
    boxSizing: "border-box",
    borderRadius: "2px",
    backgroundColor: theme.ModalBGColor,
    boxShadow: "2px 2px 4px black",
    width: 440,
    userSelect: "none",
  },
  dialogTitleDefault: {
    fontSize: 14,
    fontWeight: "600",
    lineHeight: "20px",
    padding: 0,
    color: theme.HeaderSelectedText,
  },
  dialogTitleWarning: {
    fontSize: 14,
    fontWeight: "600",
    lineHeight: "20px",
    padding: 0,
    color: theme.delayedStopMarkerColor,
  },
  dialogContent: {
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    overflow: "hidden",
    padding: "16px 0px",
  },
  button: {
    fontSize: 14,
    textTransform: "none",
    borderRadius: "2px",
    margin: 0,
    width: "47%",
    "&$buttonDisabled": {
      backgroundColor: theme.customInputBGColor,
      color: theme.TextColor,
      cursor: "not-allowed",
      opacity: 0.8,
    }
  },
  singleActionButton: {
    width: "fit-content"
  },
  redButton: {
    backgroundColor: theme.delayedStopMarkerColor,
    color: theme.ModalBGColor,
  },
  dialogAction: {
    justifyContent: "space-between",
    margin: 0,
    "&$actionButton": {
      paddingBottom: 0,
      paddingRight: 0,
    },
  },
  actionButton: {
    margin: 0,
    padding: 0,
    display: "flex",
    justifyContent: "space-between",
  },
  singleButtonGroup: {
    justifyContent: "flex-end"
  },
  userInfo: {
    color: theme.HeaderSelectedText,
    fontWeight: "bold",
  },
  dialogMsg: {
    display: "flex",
    flexDirection: "column",
  },
  buttonDisabled: {},
  message:{
    wordWrap: "break-word"
  },
  circularProgress: {
    color: theme.white,
  }
});

const CustomConfirmationDialog = ({
  classes,
  title,
  children,
  onConfirm,
  onCancel,
  cancelButtonLabel,
  confirmButtonLabel,
  mode,
  disabled=false,
  loading=false
}) => {
  const rootClass = `${classes.button} ${mode === "danger" ? classes.redButton : ""} ${
    !cancelButtonLabel ? classes.singleActionButton : ''
  }`;
  const actionButtonGroupClass = `${classes.actionButton} ${
    cancelButtonLabel ? '' : classes.singleButtonGroup
  }`;
  return (
    <Dialog
      open={true}
      aria-labelledby="UserDeletion-title"
      classes={{ paper: classes.dialog, root: classes.root }}
      maxWidth="sm"
    >
      <DialogTitle
        id="UserDeletion-title"
        classes={{
          root:
            mode === "danger"
              ? classes.dialogTitleWarning
              : classes.dialogTitleDefault,
        }}
        disableTypography
      >
        {title}
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        <Grid container spacing={24}>
          <Grid item xs={12} className={classes.message}>
            {children}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogAction }}>
        <Grid container spacing={24}>
          <Grid item xs={12} classes={{ item: actionButtonGroupClass }}>
            {cancelButtonLabel && (
              <Button
                variant="outlined"
                color={mode === "danger" ? "secondary" : "primary"}
                size="small"
                className={classes.button}
                onClick={onCancel}
                >
                {cancelButtonLabel}
              </Button>
            )}
            <Button
              variant="contained"
              color={mode !== "danger" ? "primary" : ""}
              disabled={disabled || loading}
              size="small"
              disableRipple
              classes={{ root: rootClass, disabled: classes.buttonDisabled }}
              onClick={loading ? null : onConfirm}
            >
              {loading ? <CircularProgress classes={{ root: classes.circularProgress }} size={16} /> : confirmButtonLabel}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(CustomConfirmationDialog);
